import dayjs from 'dayjs';
import { RangeOptions } from '../../components/input/dateInput/dateInput';

export type AnalyticsWidgetRouteParams = {
  teamId?: string
}

export const AnalyticsWidgetDateRangePresets: RangeOptions[] = [{
  name: 'Today',
  getRange: () => {
    return [dayjs(), dayjs()];
  }
},
{
  name: 'Yesterday',
  getRange: () => {
    return [dayjs().subtract(1, 'day'), dayjs().subtract(1, 'day')];
  }
},
{
  name: 'Last Week',
  getRange: () => {
    return [dayjs().subtract(7, 'day'), dayjs()];
  }
},
{
  name: 'Last 30 Days',
  getRange: () => {
    return [dayjs().subtract(31, 'day'), dayjs()];
  }
},
{
  name: 'This Month',
  getRange: () => {
    return [dayjs().startOf('month'), dayjs().endOf('month')]
  }
}];
